import { useState, useContext, useRef, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { User, LogOut, Bell, Settings } from "lucide-react";
import SuryaLogoMain from "../../assets/images/logo/logo11.png";
import DummyImg from "../../assets/images/user-dummy-img.jpg";
import LogoutConfirmModal from "./LogoutConfirmModal";
import { AuthContext } from "../../Context/ContextFunctions";
import ProfileModel from "./ProfileModel";
import { NotificationCount } from "../../services/Notification/NotificationApi";


import MyTeamModal from "./MyTeamModal";
import { hasAnyViewPermission, hasViewPermission } from "../../Utils/stringFormatter";
const Navbar = () => {
  const dropdownRef = useRef(null);
  const [mobileMenu, setMobileMenu] = useState(false);
  const [userProfile, setUserProfile] = useState(false);
  const [userProfileOpenPopup, setUserProfileOpenPopup] = useState(false);
  const [myTeamModalOpenPopup, setMyTeamModalOpenPopup] = useState(false);
  const [showConfirmationModal, setConfirmationModal] = useState(false);
  const [isOfficeToolsOpen, setOfficeToolOpen] = useState(false);
  const navigate = useNavigate();
  const {
    authDetails,
    fetchNotificationCount,
    notificationCount
  } = useContext(AuthContext);
  const user = JSON.parse(localStorage.getItem('login') || '{}');
  const location = useLocation(); // Get the current route
  const menuRef = useRef(null);
  const clientKeyID = localStorage.getItem("clientKeyID");

  const permissionModuleList = JSON.parse(localStorage.getItem("permissions"));

  const hasTabAccess = (compareName = []) => {
    // debugger;
    if (!Array.isArray(compareName)) return false;

    return permissionModuleList?.some((module) =>
      compareName.some(
        (name) =>
          module.compareName?.toLowerCase() === name?.toLowerCase() &&
          module.isaccessible === 1
      )
    );
  };

  const menuItems = [
    {
      name: "Dashboard",
      path: "/",
      activePaths: ["/"],
      access: true,
      compareName: ["Dashboard"],
      moduleName: "Dashboard",
    },
    {
      name: "Employee",
      path: "/staff",
      activePaths: ["/staff", "/viewStaff", "/viewLog"],
      access: true,
      compareName: ["Employee", "ActiveUser"],
      moduleName: "Employee",
    },
    {
      name: "Parties",
      path: "/client",
      activePaths: clientKeyID
        ? ["/client", "/addUpdateClient", "/viewClient", "/addUpdateJob"]
        : ["/client", "/addUpdateClient", "/viewClient"],
      access: true,
      compareName: ["Tender", "Client", "Vendor", "Parties"],
      moduleName: "Parties",
    },
    {
      name: "Project",
      path: "/project",
      activePaths: clientKeyID ? ["/project"] : ["/project"],
      access: true,
      compareName: ["Project"],
      moduleName: "Project",
    },
    {
      name: "Jobs",
      path: "/jobs",
      activePaths: clientKeyID ? ["/jobs"] : ["/jobs"],
      access: true,
      compareName: "Jobs",
      moduleName: "Jobs",
    },
    {
      name: "Duty Slip",
      path: "/duty-slip",
      activePaths: ["/duty-slip"],
      access: true,
      compareName: ["Daily Duty", "Weekly Progress"],
      moduleName: ["Daily Duty", "Weekly Progress"],
    },
    {
      name: "Account",
      path: "/wallet",
      activePaths: ["/wallet", "/wallet/view-logs"],
      compareName: ["Wallet Balance", "Office Expense", "Advance Salary", "Business Development Expense"],
      moduleName: "Account",
    },
    {
      name: "Reports",
      path: "/report",
      activePaths: ["/report", "/expense-report"],
      access: true,
      compareName: [
        "Job Report",
        "Project Report",
        "Attendance Report",
        "Expense Report",
        "Tender Status Report",
        "Tender Report",
        "KRA Report",
        "Payment Summary Report",
        "Profit Loss Report",
        "Profitability Report",
        "Service Report",
        "Task Report",
        "Team Performance Report",
        "Wallet Report",
      ],
      moduleName: "Job Report",
    },
    // {
    //   name: "Data Bank",
    //   path: "/data-bank",
    //   activePaths: ["/data-bank"],
    //   access: true,
    //   compareName: ["Data Bank"],
    //   moduleName: "Data Bank",
    // },
  ];

  // Rendered inside the profile dropdown instead of the main menu bar
  const configureMenuItem = {
    name: "Configure",
    path: "/configure",
    compareName: [
      "Divisional Category",
      "Divisional SubCategory",
      "Department",
      "Designation",
      "Zone",
      "Location",
      "Job",
      "City",
      "RoleType",
    ],
    moduleName: "DivisionalCategory",
  };


  useEffect(() => {
    if (!authDetails?.userKeyID) return;

    // Fetch immediately on route change
    fetchNotificationCount(authDetails.userKeyID);

    // Fetch every 2 minutes (120000 ms)
    const intervalId = setInterval(() => {
      fetchNotificationCount(authDetails.userKeyID);
    }, 120000);

    // Cleanup on route change / unmount
    return () => {
      clearInterval(intervalId);
    };
  }, [location.pathname, authDetails?.userKeyID]);


  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setUserProfile(false);
      }
    }

    if (userProfile) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [userProfile]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setMobileMenu(false);
      }
    };

    if (mobileMenu) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [mobileMenu]);
  const handleLogout = () => {
    setConfirmationModal(true);
  };

  useEffect(() => {
    if (mobileMenu) {
      document.body.style.overflow = "hidden"; // Disable scroll
    } else {
      document.body.style.overflow = ""; // Enable scroll
    }
    return () => {
      document.body.style.overflow = ""; // Cleanup on unmount
    };
  }, [mobileMenu]);

  const onConfirmLogout = () => {
    localStorage.clear();
    navigate("/login");
    window.location.reload();
    setConfirmationModal(false);
  };


  const getNotificationCount = async () => {

    try {
      const response = await NotificationCount(authDetails.userKeyID);
      if (response.statusCode === 200) {
        const list = response.responseData?.data;
        // setNotificationViewCount(response.responseData.notificationCount);


      } else {
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <nav className="bg-[#135ea0] shadow-md">
        <div className="mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center">
            <div className="flex items-center space-x-4 gap-[100px]">

              <div
                style={{
                  width: "60px",
                  height: "60px",
                  borderRadius: "50%",
                  overflow: "hidden",
                  position: "relative",
                  cursor: "pointer",
                  margin: "2px"
                }}
              >
                <img
                  src={SuryaLogoMain}
                  alt="Company Logo"
                  style={{
                    position: "absolute",
                    top: "0px",          // adjust to show desired part
                    left: "0px",
                    width: "auto",         // use natural image size
                    height: "100%",        // fill the circle vertically
                    transition: "transform 0.3s ease-in-out", // smooth zoom
                  }}
                  className="hover:scale-125"

                />
              </div>

              <div className="hidden sm:flex flex-col">
                <div className="flex space-x-4 mb-2">
                  {menuItems
                    .filter((item) =>
                      Array.isArray(item.compareName)
                        ? hasAnyViewPermission(item.compareName)
                        : hasViewPermission(item.moduleName)
                    )
                    .map((item, index) => (

                      <div key={index} className="relative">
                        {item.subMenu ? (
                          // Check if at least one subItem has access
                          item.subMenu.some(
                            (subItem) => subItem.access !== false
                          ) && (
                            <div
                              className="relative -mt-1"
                              onMouseEnter={() => setOfficeToolOpen(index)}
                              onMouseLeave={() => setOfficeToolOpen(null)}
                            >
                              <button
                                className={`text-12 transition px-3 py-2 rounded-md flex items-center relative ${item.activePaths.includes(location.pathname)
                                  ? "text-white bg-[#eca15f ]"
                                  : "text-[#135EA0] hover:text-blue-700"
                                  }`}
                              >
                                {item.name}
                                <svg
                                  className="ml-1 w-4 h-4"
                                  fill="none"
                                  stroke="currentColor"
                                  viewBox="0 0 24 24"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="2"
                                    d="M19 9l-7 7-7-7"
                                  ></path>
                                </svg>
                              </button>
                              {isOfficeToolsOpen === index && (
                                <div className="text-12 absolute left-0 top-[calc(100%-2px)] w-48 bg-white shadow-lg rounded-md z-50 border border-gray-200">
                                  {item.subMenu
                                    .filter(
                                      (subItem) => subItem.access !== false
                                    )
                                    .map((subItem, subIndex) => (
                                      <Link
                                        key={subIndex}
                                        to={subItem.path}
                                        className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                                        onClick={() => setOfficeToolOpen(null)}
                                      >
                                        {subItem.name}
                                      </Link>
                                    ))}
                                </div>
                              )}
                            </div>
                          )
                        ) : (
                          <Link
                            to={item.path}
                            className={`text-sm font-medium transition-all duration-300 px-3 py-2 rounded-md relative ${item.activePaths.includes(location.pathname)
                              ? "text-white bg-gradient-to-r from-[#0E4C84] to-[#00A7C1] shadow-md shadow-cyan-500/30"
                              : "text-[#D9E8FF] hover:text-white hover:bg-gradient-to-r hover:from-[#135EA0] hover:to-[#00A7C1] hover:shadow-md hover:shadow-cyan-400/30"
                              }`}
                          >
                            {item.name}
                          </Link>
                        )}
                      </div>
                    ))}
                </div>
              </div>
            </div>

            <div className="sm:hidden">
              <span className="font-bold text-14 mb-2">
                {user?.name}
              </span>
            </div>

            <button
              className="sm:hidden p-2 focus:outline-none"
              onClick={() => setMobileMenu(!mobileMenu)}
            >
              <svg
                className="w-6 h-6 text-gray-700"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M4 6h16M4 12h16m-7 6h7"
                ></path>
              </svg>
            </button>
            <div className="flex items-center space-x-4 relative">
              {/* Notification Bell */}
              <button
                onClick={() => {
                  if (mobileMenu) {
                    setMobileMenu(!mobileMenu);
                  }
                  navigate("/notification");
                }}
                className="relative focus:outline-none"
              >
                <Bell size={26} style={{ color: "white" }} />
                {notificationCount > 0 && (
                  <span className="absolute -top-[0.55rem] -right-1 bg-[#E86B1B] text-white text-xs w-5 h-5 flex items-center justify-center rounded-full">
                    {notificationCount}
                  </span>
                )}
              </button>

              {/* Profile Section */}
              <div className="relative">
                <button
                  onClick={() => {
                    if (mobileMenu) {
                      setMobileMenu(!mobileMenu);
                    }
                    setUserProfile(!userProfile);
                  }}
                  className="focus:outline-none"
                >
                  <img
                    className="w-10 h-10 rounded-full"
                    src={DummyImg}
                    alt="User"
                    style={{
                      marginTop: "6px",
                      padding: "2px",
                      border: "2px solid white",
                    }}
                  />

                </button>

                {/* Dropdown Menu */}
                {userProfile && (
                  <div
                    ref={dropdownRef}
                    className="z-10 text-12 absolute right-0 mt-2 w-60 bg-white rounded-md shadow-lg top-[3rem] ring-1 ring-gray-300"
                  >
                    <p className="px-4 py-2 font-bold text-12">
                      Hello, {user?.name}
                    </p>
                    <Link
                      to="/profile-details"
                      onClick={() => setUserProfile(!userProfile)}
                      className="flex items-center px-4 py-2 text-gray-700 hover:bg-gray-200"
                    >
                      <User size={16} className="mr-2" /> Profile
                    </Link>

                    {hasAnyViewPermission(configureMenuItem.compareName) && (
                      <Link
                        to={configureMenuItem.path}
                        onClick={() => setUserProfile(!userProfile)}
                        className="flex items-center px-4 py-2 text-gray-700 hover:bg-gray-200"
                      >
                        <Settings size={16} className="mr-2" /> Configure
                      </Link>
                    )}

                    <button
                      className="flex w-full items-center px-4 py-2 text-gray-700 hover:bg-gray-200"
                      onClick={handleLogout}
                    >
                      <LogOut size={16} className="mr-2" /> Logout
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        {mobileMenu && (
          <div ref={menuRef} className="sm:hidden bg-white shadow-md">
            <div className="flex flex-col space-y-2 p-4">
              {menuItems
                .filter((tab) => hasTabAccess(tab.compareName))
                .map((item, index) => {
                  // Check if the item has subMenu with at least one accessible item
                  const hasAccessibleSubMenu =
                    item.subMenu &&
                    item.subMenu.some((subItem) => subItem.access !== false);

                  return (
                    <div key={index}>
                      {hasAccessibleSubMenu ? (
                        <div>
                          <button
                            onClick={() =>
                              setOfficeToolOpen(
                                isOfficeToolsOpen === index ? null : index
                              )
                            }
                            className={`block text-12 rounded-md px-3 py-2 flex justify-between w-full ${item.activePaths.includes(location.pathname)
                              ? "text-white bg-[#E86B1B]"
                              : "text-[#135EA0] hover:bg-blue-200"
                              }`}
                          >
                            {item.name}
                            <svg
                              className={`w-4 h-4 transform ${isOfficeToolsOpen === index ? "rotate-180" : ""
                                }`}
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M19 9l-7 7-7-7"
                              ></path>
                            </svg>
                          </button>
                          {isOfficeToolsOpen === index && (
                            <div className="text-12 ml-4 mt-1 space-y-1">
                              {item.subMenu
                                .filter((subItem) => subItem.access !== false) // Only show allowed sub-items
                                .map((subItem, subIndex) => (
                                  <Link
                                    key={subIndex}
                                    to={subItem.path}
                                    className="block text-12 px-3 py-2 text-sm text-gray-700 hover:bg-gray-100 rounded-md"
                                    onClick={() => setMobileMenu(false)}
                                  >
                                    {subItem.name}
                                  </Link>
                                ))}
                            </div>
                          )}
                        </div>
                      ) : (
                        <Link
                          to={item.path}
                          className={`block text-12 rounded-md px-3 py-2 ${location.pathname === item.path
                            ? "text-white bg-[#E86B1B]"
                            : "text-[#135EA0] hover:bg-blue-200"
                            }`}
                          onClick={() => setMobileMenu(false)}
                        >
                          {item.name}
                        </Link>
                      )}
                    </div>
                  );
                })}
            </div>
          </div>
        )}
      </nav>

      {userProfileOpenPopup && (
        <ProfileModel
          isOpen={userProfileOpenPopup}
          onClose={() => setUserProfileOpenPopup(false)}
        />
      )}

      {myTeamModalOpenPopup && (
        <MyTeamModal
          isOpen={myTeamModalOpenPopup}
          onClose={() => setMyTeamModalOpenPopup(false)}
        />
      )}
      {/* Logout Confirmation Modal */}
      {showConfirmationModal && (
        <LogoutConfirmModal
          show={showConfirmationModal}
          onHide={() => setConfirmationModal(false)}
          onConfirm={onConfirmLogout}
        />
      )}
    </>
  );
};

export default Navbar;

